import { Component } from '@theme/component';

/**
 * @typedef {object} UniformsGalleryRefs
 * @property {HTMLElement[]} [slides]
 * @property {HTMLButtonElement[]} [thumbs]
 */

/**
 * @extends {Component<UniformsGalleryRefs>}
 */
class UniformsGallery extends Component {
  /**
   * @param {number} index
   */
  preload(index) {
    const { slides = [] } = this.refs;
    const image = slides[index]?.querySelector('img[loading="lazy"]');
    if (image) image.loading = 'eager';
  }

  /**
   * @param {number} index
   */
  select(index) {
    const { slides = [], thumbs = [] } = this.refs;
    if (!slides[index]) return;

    this.preload(index);

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === index;
      slide.hidden = !isActive;

      if (!isActive) {
        for (const video of slide.querySelectorAll('video')) video.pause();
      }
    });

    thumbs.forEach((thumb, thumbIndex) => {
      if (thumbIndex === index) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });
  }
}

if (!customElements.get('uniforms-gallery')) {
  customElements.define('uniforms-gallery', UniformsGallery);
}
